import React from 'react';
import { Observable } from 'rxjs';
import { ReportListItem } from '../interfaces/report-list-item';
import RemoveBtnComponent from './remove-btn-component';

interface Props {
  id: string;
  onRemove: (id: string) => Observable<ReportListItem[]>;
}

export default function RemoveBtn({ id, onRemove }: Props) {
  return (
    <RemoveBtnComponent
      id={id}
      onRemove={onRemove}
      content="pages.crop.vaad_liz_reports_v2.remove_modal.remove"
      label="pages.crop.vaad_liz_reports_v2.list.remove"
      prefix="remove-btn"
    />
  );
}
